module.exports = __webpack_public_path__ + "img/erp-logos-solbox.33f484dc.jpg";